import React from "react";
import { RightArrow } from "../../assets/icons/icons";

export default function Card({ title, idNumber, imageSrc }) {
  return (
    <article className="w-full cursor-pointer rounded-[20px] border-[2px] border-transparent pb-[20px] pl-[15px] pr-[20px] pt-[15px] transition-transform duration-300 ease-in-out hover:-translate-y-[10px] hover:border-[#ff6b00] hover:shadow-lg">
      <header className="flex flex-row items-center justify-between">
        <img src={imageSrc} alt="img" className="h-[44px] w-[44px]" />
        <RightArrow />
      </header>
      <h1 className="mb-[8px] mt-[10px] text-left font-outfit text-[16px] font-semibold leading-[20.16px] text-[#222222]">
        {title}
      </h1>
      <p className="text-left font-outfit text-[12px] font-normal leading-[15.12px] text-[#666666]">
        ID No : {idNumber}
      </p>
    </article>
  );
}
